import { useState, useEffect, useRef } from 'react'
import FirestoreMonitor from '../services/FirestoreMonitor'

const FirestoreStatsWidget = () => {
  const [stats, setStats] = useState(FirestoreMonitor.getStats())
  const [isVisible, setIsVisible] = useState(true)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [position, setPosition] = useState({ x: window.innerWidth - 232, y: 16 })
  const [isDragging, setIsDragging] = useState(false)
  const dragStart = useRef({ x: 0, y: 0 })

  useEffect(() => {
    // Subskrybuj zmiany w monitorze
    const unsubscribe = FirestoreMonitor.subscribe(() => {
      setStats(FirestoreMonitor.getStats())
    })

    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (!isDragging) return

    const handleMouseMove = (e: MouseEvent) => {
      setPosition({
        x: e.clientX - dragStart.current.x,
        y: e.clientY - dragStart.current.y
      })
    }

    const handleMouseUp = () => {
      setIsDragging(false)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isDragging])

  const handleMouseDown = (e: React.MouseEvent) => {
    if ((e.target as HTMLElement).tagName === 'BUTTON') return
    setIsDragging(true)
    dragStart.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    }
  }

  const handleReset = () => {
    FirestoreMonitor.reset()
  }

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        style={{
          position: 'fixed',
          top: '16px',
          right: '16px',
          backgroundColor: '#d4af37',
          color: '#fff',
          border: 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          fontSize: '18px',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        title="Pokaż statystyki Firestore"
      >
        📊
      </button>
    )
  }

  return (
    <div 
      style={{
        position: 'fixed',
        top: `${position.y}px`,
        left: `${position.x}px`,
        backgroundColor: '#fff',
        border: '2px solid #d4af37',
        borderRadius: '8px',
        padding: isCollapsed ? '8px 12px' : '12px 16px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        zIndex: 9999,
        minWidth: isCollapsed ? 'auto' : '200px',
        cursor: isDragging ? 'grabbing' : 'grab',
        userSelect: 'none'
      }}
      onMouseDown={handleMouseDown}
    >
      <div style={{ 
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: isCollapsed ? 0 : '8px'
      }}>
        <div style={{ 
          fontSize: '12px', 
          fontWeight: 600, 
          color: '#666',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }}>
          📊 Firestore
        </div>
        <div style={{ display: 'flex', gap: '4px' }}>
          <button
            onClick={(e) => {
              e.stopPropagation()
              setIsCollapsed(!isCollapsed)
            }}
            style={{
              padding: '2px 6px',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px'
            }}
            title={isCollapsed ? 'Rozwiń' : 'Zwiń'}
          >
            {isCollapsed ? '📈' : '📉'}
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation()
              setIsVisible(false)
            }}
            style={{
              padding: '2px 6px',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              color: '#999'
            }}
            title="Ukryj"
          >
            ✕
          </button>
        </div>
      </div>
      
      {!isCollapsed && (
        <>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
              <span>Odczyty:</span>
              <span style={{ fontWeight: 600, color: '#2196F3' }}>{stats.reads}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
              <span>Zapisy:</span>
              <span style={{ fontWeight: 600, color: '#4CAF50' }}>{stats.writes}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
              <span>Usunięcia:</span>
              <span style={{ fontWeight: 600, color: '#f44336' }}>{stats.deletes}</span>
            </div>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              fontSize: '16px',
              marginTop: '4px',
              paddingTop: '8px',
              borderTop: '1px solid #eee'
            }}>
              <span style={{ fontWeight: 600 }}>Razem:</span>
              <span style={{ fontWeight: 700, color: '#d4af37' }}>{stats.total}</span>
            </div>
          </div>

          <button
            onClick={(e) => {
              e.stopPropagation()
              handleReset()
            }}
            style={{
              width: '100%',
              padding: '6px 12px',
              backgroundColor: '#f5f5f5',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '12px',
              cursor: 'pointer',
              fontWeight: 600,
              color: '#666'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#e0e0e0'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#f5f5f5'
            }}
          >
            🔄 Reset
          </button>

          <div style={{ 
            fontSize: '10px', 
            color: '#999', 
            marginTop: '8px',
            textAlign: 'center'
          }}>
            Przeciągnij aby przesunąć
          </div>
        </>
      )}
    </div>
  )
}

export default FirestoreStatsWidget
